<template>
    <div class="staff-list-widget">

        <div class="card">
            <h3 class="card-header">Staff</h3>
            <div class="card-body">
                <data-table
                    :show-pager="true"
                    :show-filters="false"
                    :get-items="getItems"
                    :fields="fields">
                    <template v-slot:customField="slotProps">
                        <div v-if="slotProps.row.field.key === 'full_name'">
                            <b-badge :variant="slotProps.row.item.approved ? 'success' : 'danger'"
                                     v-b-popover.hover.top="slotProps.row.item.approved ? 'approved' : 'unapproved'">
                                {{ slotProps.row.item.full_name }}
                            </b-badge>
                        </div>
                        <div v-if="slotProps.row.field.key === 'actions'">
                            <b-btn size="sm"
                                   variant="secondary"
                                   @click="viewItem(slotProps.row.item)">
                                <b-icon-eye font-scale="1"/>
                            </b-btn>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'compliance_expiration'">
                            <timestamp
                                :date-warning="true"
                                :include-year="true"
                                :date="slotProps.row.item.compliance_expiration"/>
                        </div>
                    </template>
                </data-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StaffListWidget',
    data () {
        return {
            fields: [
                { key: 'full_name', sortable: true, label: 'Name' },
                { key: 'actions', sortable: false, label: 'Actions' },
            ]
        }
    },
    methods: {
        getItems (listParams) {
            const filters = { company_id: { field: 'company_id', type: 'hidden', value: this.$user.getCompanyId() } }
            const expands = []
            return this.$api.getItems(this, 'user', filters, listParams, expands)
        },
        viewItem (item) {
            this.$router.push(`/user/view/${item.id}`)
        }
    }
}
</script>
